import React from 'react'
import styled from 'styled-components'
import useOfflineMode from 'utils/hooks/useOfflineMode'

export const OfflineWrapper = styled.div`
  position: fixed;
  width: 100%;
  color: white;
  top: -25px;
  text-align: center;
  z-index: 20000;
  &.online {
    top: -25px;
    background-color: green;
    color: white;
    transition: top 300ms ease-in 500ms, background-color 300ms ease-in, color 300ms ease-in;
  }
  &.offline {
    top: 0;
    background-color: #f7e500;
    color: black;
    transition: top 300ms ease-out;
  }
`;

export default function OfflineIndicator () {
  let { online } = useOfflineMode()
  return (
    <OfflineWrapper online={online} className={online ? 'online': 'offline'}>
      You are {online ? 'online': 'offline'}
    </OfflineWrapper>
  )
}
